export default __webpack_public_path__ + "static/media/noSignatureIcon.bb2b91ac.svg";